import { documentLogin } from './documentLogin';
import { login } from './login';
import { passwordRecovery } from './passwordRecovery';
import { signup } from './signup';
import { updatePassword } from './updatePassword';

const es = {
  ...documentLogin,
  ...login,
  ...passwordRecovery,
  ...signup,
  ...updatePassword,
};

export default es;
